import { trace } from 'owa-trace';

const OPTIONS: PositionOptions = {
    enableHighAccuracy: false,
    maximumAge: 0,
    timeout: 30000,
};

export default function requestCurrentPosition(storeResultOnSuccess: (position: Position) => void) {
    // Use the browser's API to request position
    // https://developer.mozilla.org/en-US/docs/Web/API/Position
    if (!navigator || !navigator.geolocation) {
        return;
    }
    navigator.geolocation.getCurrentPosition(
        (position: Position) => onGetCurrentPositionSuccess(position, storeResultOnSuccess),
        onGetCurrentPositionError,
        OPTIONS
    );
}

function onGetCurrentPositionSuccess(
    position: Position,
    storeResultOnSuccess: (position: Position) => void
): void {
    if (!position || !position.coords) {
        trace.warn(
            'Browser returned success for GetCurrentPosition, but invalid position or coordinates'
        );
        return;
    }

    storeResultOnSuccess(position);
}

function onGetCurrentPositionError(positionError: PositionError): void {
    switch (positionError.code) {
        case positionError.PERMISSION_DENIED:
        case positionError.POSITION_UNAVAILABLE:
        case positionError.TIMEOUT:
            trace.info(positionError.message);
            break;
        default:
            trace.error(`Error getting position from browser: ${positionError.message}`);
            break;
    }
}
